import {
    REFERENCE_NUMBER_SET_VALUE,
    FIRST_NAMES_SET_VALUE,
} from '../../actions/easiplusFuneralPlan/thankYou';

export const initThankYou = {
    referenceNumber: null,
    firstNames: null,
};

export default (state = initThankYou, action) => {
    switch (action.type) {
        case REFERENCE_NUMBER_SET_VALUE:
            return { ...state, referenceNumber: action.value };
        case FIRST_NAMES_SET_VALUE:
            return { ...state, firstNames: action.value };
        default:
            return state;
    }
}